import { ref, get } from "firebase/database";
import { fetchData, updateData } from "../firebase/firebase_methods";
import { database } from "../../firebaseConfig";
import { databaseKey } from "../common/database_key";

const collectionName = databaseKey();

const fetchDropdownData = async (path) => {
  try {
    const dataRef = ref(database, `${path}/`);
    const snapshot = await get(dataRef);
    if (snapshot.exists()) {
      return Object.values(snapshot.val());
    }
    return [];
  } catch (error) {
    console.error(`Error fetching ${path}:`, error);
    return [];
  }
};

export const fetchSubjects = () =>
  fetchDropdownData(`${collectionName}/subjects`);
export const fetchLanguages = () =>
  fetchDropdownData(`${collectionName}/languages`);

export const saveNewItem = async (field, itemName) => {
  const itemRef = fetchData(`${field}/${itemName.toLowerCase()}`);
  await updateData(itemRef, { name: itemName });
};

export const cleanData = (data) => {
  const cleanedData = { ...data };

  if (!cleanedData.pricing.amount) delete cleanedData.pricing;
  if (!cleanedData.teachingLocation.address)
    delete cleanedData.teachingLocation;

  cleanedData.timings = cleanedData.timings.filter(
    (slot) => slot.startTime.trim() !== "" || slot.endTime.trim() !== ""
  );

  if (cleanedData.timings.length === 0) {
    delete cleanedData.timings;
  }

  cleanedData.dynamicFields = cleanedData.dynamicFields.filter(
    (field) => field.trim() !== ""
  );

  if (cleanedData.dynamicFields.length === 0) {
    delete cleanedData.dynamicFields;
  }

  return cleanedData;
};
